var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.143,
    height: 12,
    viewBox: "0 0 9.143 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "lock_open_FILL0_wght400_GRAD0_opsz48",
    d: "M8.857,6.086h5.571V4.714A1.859,1.859,0,0,0,11.257,3.4a1.79,1.79,0,0,0-.543,1.314H9.857a2.617,2.617,0,0,1,.793-1.921,2.725,2.725,0,0,1,3.843,0,2.617,2.617,0,0,1,.793,1.921V6.086h1a.854.854,0,0,1,.857.857v6.2a.854.854,0,0,1-.857.857H8.857A.854.854,0,0,1,8,13.143v-6.2a.854.854,0,0,1,.857-.857Zm0,7.057h7.429v-6.2H8.857Zm3.714-2a1.073,1.073,0,0,0,.779-.314,1.021,1.021,0,0,0,.321-.757,1.125,1.125,0,0,0-.321-.779,1.041,1.041,0,0,0-1.557,0,1.125,1.125,0,0,0-.321.779,1.021,1.021,0,0,0,.321.757A1.073,1.073,0,0,0,12.571,11.143Zm-3.714,2v0Z",
    transform: "translate(-8 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock_open.6011d9882728e9570fd07c03c6147809.svg";
export { ForwardRef as ReactComponent };